<template>
  <div>
    <div class="slider_selection_container">
      <label class="label">
          {{ inputName }}
      </label>
      <div class="slider_selection">
        {{ selected_value }}
      </div>
    </div>

      <vue-slider 
          v-model="field.value" 
          :interval="interval"
          :max="max"
          :min="min"
          :data = "slider_data"
          :data-value="'id'"
          :data-label="'name'"
          :tooltip="'none'"
          @change="modified"
          dotSize="12"
          :marks="defined_marks"
          :hide-label="true"
          :adsorb="true"
      />
      <br/>
      <!-- <div>slider selected value: {{ field.value }}</div> -->
    <p class="help is-danger" style="margin-bottom: 20px;" v-if="field.error">{{ field.error }}</p>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import "@/assets/vue-slider-cardiff.css";
// import { format } from "core-js/core/date";
export default {
  name: "Slider",
  components: { VueSlider },
  model() {
    return { value: initialValue ? initialValue : "", error: "", typed: false };
  },
  props: {
    inputField: Object,
    inputName: String,
    interval: Number,
    max: Number,
    min: Number,
    slider_data: Array,
    format: String,
    initialValue: String,
    marks: Boolean
  },
  created: function () {
      // console.log(this.slider_data);
      console.log('created?');
      this.defined_marks = this.marks ? this.marks : []
  },
  data() {
    return {
      slider_value : null,
      field: this.inputField,
      selected_value : "",
      defined_marks : []
    };
  },
  methods: {
    modified() {
      this.field.typed = true;
      this.setVal(this.field.value.id);
      this.validate();
    },
    validate() {
      // console.log("validating slider", this.field.value);
      this.field.error = null;
      if (!this.field.value) {
        this.field.error = "You must select a value.";
      }
      return this.field.error == null;
    },
    setVal(new_value) {
      // console.log("setting value:" + new_value);
      this.field.value = new_value;
      this.selected_value = new_value;
      if(this.format ==='money' && new_value !== ""){
        let selected_value_string = new_value
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.selected_value = "$ " + selected_value_string;
      }
    },
    initialSelectedValue(new_value){
      this.selected_value = new_value;
      if(this.format ==='money' && new_value !== ""){
        let selected_value_string = new_value
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.selected_value = "$ " + selected_value_string;
      }
      console.log('calling initialSelectedValue from slider', new_value);
      // this.$refs.slider.setValue(new_value);
      // this.$refs.slider.setIndex(3)
    },
    selectInput() {
      this.modified();
      this.validate();
    }
  },
};
</script>
<style scoped>
.field {
  padding: 20px 20px;
  background: #edf0f3;
  border-radius: 5px;
  margin: 12px 0px;
}

.selected {
  background: #f0f4ff;
}
.slider_selection_container{
  display: inline-flex;
  width: 100%;
}
.label{
  width: 70%;
  /* color: #363636; */
}
.slider_selection{
  width: 29%;
  text-align: right;
}
</style>
